import { FontScale } from "./scale";

export const fontSizes = FontScale().map((step: any) => `${step}rem`);
export const fonts = {
  sans:
    "Helvetica Neue, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
  serif: "Value Serif, Georgia, serif",
};
